import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { ISummaryUsageDTO } from "../../services/setpoint-administration-service/Models";
import SetpointAdministrationDataService from "../../services/setpoint-administration-service/SetpointAdministrationService";
import { useQuery } from "react-query";

export type UseSetpointUsageDataParams = {
    groupID: number,
    setpointID: number,
} & BaseUseQueryParameters<ISummaryUsageDTO[] | undefined>;

export function useSetpointUsageData({
    groupID,
    setpointID,
    enabled,    
    onSuccess,
    onError
}: UseSetpointUsageDataParams) {
    return useQuery<ISummaryUsageDTO[], RestError>(
        keys.setPointUsage(groupID, setpointID),
        ({ signal }) => {
            return SetpointAdministrationDataService.getSetpointUsage(
                groupID, 
                setpointID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            refetchOnMount: true,
            staleTime: 0,
        }
    );
}